export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      gallery: "Galeri",
      perf: "Sahne",
      events: "Programlar",
      hotel: "Otel & Casino",
      reserve: "Rezervasyon",
      careers: "Kariyer",
      contact: "İletişim",
      book: "Masa Ayır",
    },
    hero: {
      overline: "Girne, KKTC • Premium Gece Kulübü",
      line1: "Gecenin",
      line2: "En Işıltılı",
      line3: "Adresi",
      desc: "Canlı sahne performansları, imza kokteyller ve unutulmaz bir atmosfer. VIP1 Night Club'da her gece bir gösteriye dönüşür.",
      cta1: "Masanı Ayır",
      cta2: "Programları Gör",
      scroll: "Kaydır",
    },
    marquee: ["CANLI SAHNE", "İMZA KOKTEYLLER", "VIP LOCALAR", "DJ PERFORMANS", "ÖZEL ETKİNLİKLER"],
    about: {
      overline: "Hakkımızda",
      title: "Sıradan bir gece değil, bir deneyim.",
      desc: "VIP1 Night Club, sofistike eğlence anlayışını zarafetle buluşturur. Şehrin kalbinde, seçkin misafirlerimize kusursuz bir gece sunmak için tasarlandı.",
      chapters: [
        { no: "01", title: "Atmosfer", text: "Işık, ses ve tasarımın kusursuz uyumu. Her köşe, unutulmaz anlar için özenle kurgulandı." },
        { no: "02", title: "Sahne & Sanat", text: "Profesyonel dansçılar ve canlı performanslarla sanatsal, şık bir gösteri deneyimi." },
        { no: "03", title: "Misafirperverlik", text: "Profesyonel konsomatris ve host ekibi eşliğinde VIP localar, kişiye özel servis ve ayrıcalıklı bir karşılama." },
      ],
    },
    gallery: {
      overline: "Galeri",
      title: "Sahnenin Ritmi",
      desc: "Zarif performanslar ve lüks atmosferden kareler.",
    },
    hotel: {
      overline: "Otel & Casino",
      title: "Otel ve Casino Deneyimi",
      desc: "Girne'nin en seçkin otel ve casinolarıyla ayrıcalıklı iş birliği. Konforlu konaklama, heyecan dolu oyun salonları ve premium eğlence tek çatı altında.",
      features: [
        { no: "01", title: "Lüks Konaklama", text: "Partner 5 yıldızlı otellerde ayrıcalıklı oda ve süit seçenekleri." },
        { no: "02", title: "Casino Salonları", text: "7/24 açık oyun salonları, canlı masalar ve ödüllü bir atmosfer." },
        { no: "03", title: "Özel Organizasyon", text: "Otel, villa ve rezidanslarınız için özel etkinlik organizasyonu: sahne performansı, DJ, ikram ve VIP servis ekibiyle deneyim ayağınıza gelsin." },
        { no: "04", title: "Lüks Transfer", text: "Otel, casino ve kulüp arasında özel VIP araç ile konforlu ve güvenli ulaşım." },
      ],
    },
    perf: {
      overline: "Sahne & Show",
      title: "Gecenin Yıldızları",
      desc: "Profesyonel sanatçılarımızla her gece büyüleyici bir gösteri. Estetik, enerji ve zarafet bir arada.",
      items: [
        { title: "Direk Dansı", text: "Profesyonel direk dansı sanatçılarından akrobatik ve estetik sahne gösterileri." },
        { title: "Oryantal & Dansöz Şov", text: "Büyüleyici oryantal dans ve dansöz performanslarıyla otantik bir gece atmosferi." },
        { title: "Canlı DJ & Sahne", text: "Her gece canlı DJ setleri, ışık şovu ve sahne performanslarıyla dorukta enerji." },
      ],
    },
    events: {
      overline: "Haftalık Program",
      title: "Bu Hafta Sahnede",
      desc: "Her gece farklı bir tema, farklı bir enerji.",
      book: "Rezervasyon",
      list: [
        { day: "Perşembe", title: "Latin Gecesi", time: "22:00 - 04:00", tag: "Canlı Bando" },
        { day: "Cuma", title: "Signature Show", time: "23:00 - 05:00", tag: "Sahne Performansı" },
        { day: "Cumartesi", title: "VIP Deluxe Night", time: "23:00 - 05:00", tag: "Özel DJ Set" },
        { day: "Pazar", title: "Lounge & Chill", time: "21:00 - 03:00", tag: "Akustik" },
      ],
    },
    reserve: {
      overline: "Rezervasyon",
      title: "Masanı Ayır",
      desc: "Özel gecen için yerini şimdiden garantile. Ekibimiz en kısa sürede seninle iletişime geçer.",
      name: "Ad Soyad",
      phone: "Telefon",
      date: "Tarih",
      pickDate: "Tarih seç",
      guests: "Kişi Sayısı",
      occasion: "Özel Gün (opsiyonel)",
      occasionPh: "Doğum günü, kutlama...",
      notes: "Notlar (opsiyonel)",
      notesPh: "İsteklerini bize ilet",
      submit: "Rezervasyon Talebi Gönder",
      submitting: "Gönderiliyor...",
      success: "Rezervasyon talebin alındı! Ekibimiz kısa sürede arayacak.",
      invalid: "Lütfen zorunlu alanları doldurun (ad, telefon, tarih, kişi sayısı).",
      error: "Bir hata oluştu. Lütfen tekrar dene.",
    },
    careers: {
      overline: "Kariyer",
      title: "Ekibimize Katıl",
      desc: "Profesyonel konsomatris, sahne dansçısı, host/hostes ve servis ekibi için başvurular açık. Yeteneğini bizimle paylaş.",
      name: "Ad Soyad",
      phone: "Telefon",
      position: "Pozisyon",
      pickPosition: "Pozisyon seç",
      positions: ["Sahne Dansçısı", "Konsomatris", "Host / Hostes", "Bar Personeli", "DJ", "Garson", "Güvenlik"],
      age: "Yaş",
      experience: "Deneyim (opsiyonel)",
      experiencePh: "Önceki iş deneyimlerin",
      notes: "Ek Bilgi (opsiyonel)",
      notesPh: "Bize kendinden bahset",
      submit: "Başvuru Gönder",
      submitting: "Gönderiliyor...",
      success: "Başvurun alındı! Uygun olması durumunda seninle iletişime geçeceğiz.",
      invalid: "Lütfen zorunlu alanları doldurun (ad, telefon, pozisyon).",
      error: "Bir hata oluştu. Lütfen tekrar dene.",
    },
    contact: {
      overline: "İletişim",
      title: "Bize Ulaş",
      desc: "Rezervasyon, etkinlik veya sorularınız için 7/24 buradayız.",
      phone: "Telefon",
      whatsapp: "WhatsApp",
      whatsappText: "WhatsApp'tan Yaz",
      callText: "Hemen Ara",
      hours: "Çalışma Saatleri",
      hoursValue: "7/24 Açık",
      address: "Konum",
      addressValue: "Girne, KKTC",
    },
    footer: {
      tagline: "Gecenin en ışıltılı adresi.",
      rights: "Tüm hakları saklıdır.",
      quick: "Hızlı Menü",
      legal: "18 yaş altı giriş yasaktır. Lütfen sorumlu tüketin.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      gallery: "Gallery",
      perf: "Shows",
      events: "Program",
      hotel: "Hotel & Casino",
      reserve: "Reservation",
      careers: "Careers",
      contact: "Contact",
      book: "Book a Table",
    },
    hero: {
      overline: "Kyrenia, North Cyprus • Premium Night Club",
      line1: "The Most",
      line2: "Dazzling",
      line3: "Nights",
      desc: "Live stage performances, signature cocktails and an unforgettable atmosphere. At VIP1 Night Club, every night becomes a show.",
      cta1: "Reserve Your Table",
      cta2: "View Program",
      scroll: "Scroll",
    },
    marquee: ["LIVE STAGE", "SIGNATURE COCKTAILS", "VIP LOUNGES", "DJ PERFORMANCE", "PRIVATE EVENTS"],
    about: {
      overline: "About Us",
      title: "Not just a night — an experience.",
      desc: "VIP1 Night Club blends sophisticated entertainment with true elegance. Located in the heart of the city, designed to offer our distinguished guests a flawless night.",
      chapters: [
        { no: "01", title: "Atmosphere", text: "A flawless harmony of light, sound and design. Every corner crafted for unforgettable moments." },
        { no: "02", title: "Stage & Art", text: "An artistic, refined show experience with professional dancers and live performances." },
        { no: "03", title: "Hospitality", text: "A professional konsomatris and host team, VIP lounges, personalized service and an exclusive welcome." },
      ],
    },
    gallery: {
      overline: "Gallery",
      title: "The Rhythm of the Stage",
      desc: "Frames from elegant performances and a luxurious atmosphere.",
    },
    hotel: {
      overline: "Hotel & Casino",
      title: "Hotel & Casino Experience",
      desc: "An exclusive partnership with Kyrenia's finest hotels and casinos. Comfortable stays, thrilling gaming floors and premium entertainment under one roof.",
      features: [
        { no: "01", title: "Luxury Stay", text: "Privileged room and suite options at partner 5-star hotels." },
        { no: "02", title: "Casino Floors", text: "24/7 gaming floors, live tables and an award-winning atmosphere." },
        { no: "03", title: "Private Events", text: "Bespoke event organization for your hotel, villa or residence: stage performance, DJ, catering and a VIP service team brought to you." },
        { no: "04", title: "Luxury Transfer", text: "Comfortable and safe travel between hotel, casino and club with a private VIP vehicle." },
      ],
    },
    perf: {
      overline: "Stage & Shows",
      title: "Stars of the Night",
      desc: "A mesmerizing show every night with our professional artists. Aesthetics, energy and elegance combined.",
      items: [
        { title: "Pole Art", text: "Acrobatic and aesthetic stage shows by professional pole-dance artists." },
        { title: "Oriental & Belly Dance Show", text: "An authentic night atmosphere with captivating oriental and belly-dance performances." },
        { title: "Live DJ & Stage", text: "Peak energy every night with live DJ sets, light shows and stage performances." },
      ],
    },
    events: {
      overline: "Weekly Program",
      title: "This Week On Stage",
      desc: "A different theme, a different energy every night.",
      book: "Reserve",
      list: [
        { day: "Thursday", title: "Latin Night", time: "22:00 - 04:00", tag: "Live Band" },
        { day: "Friday", title: "Signature Show", time: "23:00 - 05:00", tag: "Stage Performance" },
        { day: "Saturday", title: "VIP Deluxe Night", time: "23:00 - 05:00", tag: "Special DJ Set" },
        { day: "Sunday", title: "Lounge & Chill", time: "21:00 - 03:00", tag: "Acoustic" },
      ],
    },
    reserve: {
      overline: "Reservation",
      title: "Book Your Table",
      desc: "Secure your spot for your special night. Our team will contact you shortly.",
      name: "Full Name",
      phone: "Phone",
      date: "Date",
      pickDate: "Pick a date",
      guests: "Guests",
      occasion: "Occasion (optional)",
      occasionPh: "Birthday, celebration...",
      notes: "Notes (optional)",
      notesPh: "Tell us your requests",
      submit: "Send Reservation Request",
      submitting: "Sending...",
      success: "Your reservation request is received! Our team will call you shortly.",
      invalid: "Please fill all required fields (name, phone, date, guests).",
      error: "Something went wrong. Please try again.",
    },
    careers: {
      overline: "Careers",
      title: "Join Our Team",
      desc: "Applications open for professional konsomatris (table hostess), stage dancers, host/hostess and service staff. Share your talent with us.",
      name: "Full Name",
      phone: "Phone",
      position: "Position",
      pickPosition: "Select position",
      positions: ["Stage Dancer", "Konsomatris", "Host / Hostess", "Bar Staff", "DJ", "Waiter", "Security"],
      age: "Age",
      experience: "Experience (optional)",
      experiencePh: "Your previous work experience",
      notes: "Additional Info (optional)",
      notesPh: "Tell us about yourself",
      submit: "Send Application",
      submitting: "Sending...",
      success: "Your application is received! We will contact you if suitable.",
      invalid: "Please fill all required fields (name, phone, position).",
      error: "Something went wrong. Please try again.",
    },
    contact: {
      overline: "Contact",
      title: "Get In Touch",
      desc: "We are here 24/7 for reservations, events or any questions.",
      phone: "Phone",
      whatsapp: "WhatsApp",
      whatsappText: "Message on WhatsApp",
      callText: "Call Now",
      hours: "Opening Hours",
      hoursValue: "Open 24/7",
      address: "Location",
      addressValue: "Kyrenia, North Cyprus",
    },
    footer: {
      tagline: "The most dazzling nights.",
      rights: "All rights reserved.",
      quick: "Quick Menu",
      legal: "No entry under 18. Please drink responsibly.",
    },
  },
};

export const PHONE = "+90 548 855 23 87";
export const PHONE_RAW = "905488552387";
